export default function (Component) {
      Component.options.__docs = "# Basic usage\n\n```\n<ds-section>\n  <ds-logo></ds-logo>\n</ds-section>\n```\n\n# Inverse Logo\n\n```\n<ds-section secondary>\n  <ds-logo inverse></ds-logo>\n</ds-section>\n```"
    }